// removed by extract-text-webpack-plugin
module.exports = {"avatar":"_2md4sicVa8IxHiOCwcVP_E","name":"IWnTnD1kYUQjH7cW38uc8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ShiftsOverview/EmployeeTableItem.css
// module id = 247
// module chunks = 0